var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-body"},[_c('main',{staticClass:"c-main"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"fade-in"},[_c('router-view')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }